export const ACTION_TYPES = {
  SET_IS_FULL_SCREEN: "screen/SET_IS_FULL_SCREEN",
  SET_IS_LANDSCAPE: "screen/SET_IS_LANDSCAPE"
};

export const setIsFullScreen = (isFullScreen) => ({
  type: ACTION_TYPES.SET_IS_FULL_SCREEN,
  payload: isFullScreen
});

export const setIsLandscape = (isLandscape) => ({
  type: ACTION_TYPES.SET_IS_LANDSCAPE,
  payload: isLandscape
});
